'use client'

export default function StoreMemberships() {
  const handleCheckout = async (purchaseType: 'POINT_500' | 'PRO_MONTHLY') => {
    try {
      const res = await fetch('/api/stripe/checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ purchaseType })
      })
      const data = await res.json()
      if (data.url) {
        window.location.href = data.url
      } else {
        alert(data.error || 'Checkout failed')
      }
    } catch (err: any) {
      alert('Network error during checkout initialization.')
    }
  }

  return (
    <div id="memberships" className="pt-12 border-t border-slate-800/80">
      <div className="mb-8 text-center">
        <h2 className="text-2xl font-black text-white tracking-tight">Support & Memberships</h2>
        <p className="text-slate-400 text-sm mt-1">Get point bundles or unlock monthly Pro status.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
        
        {/* Point Top-Up Box */}
        <div className="bg-slate-900 border border-slate-800 rounded-[2rem] p-8 shadow-xl flex flex-col justify-between">
          <div>
            <h2 className="text-xl font-bold text-slate-200 mb-2">Point Top-Up</h2>
            <div className="text-3xl font-black text-white mb-6">$5.00 <span className="text-sm font-normal text-slate-500">one-time</span></div>
            <ul className="space-y-4 mb-8 text-sm text-slate-300">
              <li className="flex items-center gap-3"><span className="text-emerald-400">✓</span> Instantly receive 500 points.</li>
              <li className="flex items-center gap-3"><span className="text-emerald-400">✓</span> Claim domains and hosting instantly.</li>
              <li className="flex items-center gap-3"><span className="text-emerald-400">✓</span> Boost up to 25 threads.</li>
            </ul>
          </div>
          <button 
            onClick={() => handleCheckout('POINT_500')}
            className="w-full py-3 rounded-xl bg-slate-800 hover:bg-slate-700 text-white font-bold text-sm transition-colors shadow-md cursor-pointer"
          >
            Buy 500 Points
          </button>
        </div>

        {/* Pro Membership Box */}
        <div className="bg-slate-900 border-2 border-indigo-500 rounded-[2rem] p-8 shadow-[0_0_30px_rgba(99,102,241,0.15)] relative flex flex-col justify-between">
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-indigo-600 text-white px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg">
            Most Popular
          </div>
          <div>
            <h2 className="text-xl font-bold text-indigo-400 mb-2 mt-1">Pro Membership</h2>
            <div className="text-3xl font-black text-white mb-6">$10.00 <span className="text-sm font-normal text-slate-500">/ month</span></div>
            <ul className="space-y-4 mb-8 text-sm text-slate-300">
              <li className="flex items-center gap-3"><span className="text-indigo-400">✓</span> 1,200 points deposited every month.</li>
              <li className="flex items-center gap-3"><span className="text-indigo-400">✓</span> Exclusive glowing &quot;PRO&quot; badge on all posts.</li>
              <li className="flex items-center gap-3"><span className="text-indigo-400">✓</span> 10% discount on all marketplace claims.</li>
            </ul>
          </div>
          <button 
            onClick={() => handleCheckout('PRO_MONTHLY')}
            className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-600 to-fuchsia-600 hover:from-indigo-500 hover:to-fuchsia-500 text-white font-bold text-sm transition-all shadow-lg shadow-indigo-600/25 cursor-pointer"
          >
            Subscribe to Pro
          </button>
        </div>

      </div>
    </div>
  )
}
